import type { BlogArticlePinnedTo } from './types'

export const BLOG_ARTICLE_CATEGORIES = ['community', 'hq', 'updates'] as const

export const BLOG_ARTICLE_CATEGORY_TO_LABEL = {
  community: 'Community',
  hq: 'HQ',
  updates: 'Updates',
} as const

export const BLOG_ARTICLE_PINNED_TO_OPTIONS = ['global', 'category'] as const

export const BLOG_ARTICLE_PINNED_TO_TO_LABEL: Record<BlogArticlePinnedTo, string> = {
  global: 'Global',
  category: 'Category',
}

export const DEFAULT_BLOG_IMAGE_URL =
  'https://schoolhouse.world/assets/public/blog/schoolhouse-logo.jpg'

export const BLOG_ABOUT_ARTICLE_SLUG = 'about'

export const DEFAULT_BLOG_PAGE_SIZE = 24
